import { arrayMove } from '@dnd-kit/sortable';

export interface OrderUpdate<T> {
  item: T;
  order: number;
}

// Moves `activeId` into `overId`'s place and numbers the whole list 0, 1, 2…
// Returns only the items whose number changed, so a move usually writes a few
// docs. The list is the full shelf, including anything a filter is hiding, so
// hidden items keep their place.
export const reorder = <T>(
  list: T[],
  getId: (item: T) => string,
  getOrder: (item: T) => number | null | undefined,
  activeId: string,
  overId: string
): OrderUpdate<T>[] => {
  const oldIndex = list.findIndex((item) => getId(item) === activeId);
  const newIndex = list.findIndex((item) => getId(item) === overId);
  if (oldIndex === -1 || newIndex === -1 || oldIndex === newIndex) return [];

  return arrayMove(list, oldIndex, newIndex)
    .map((item, order) => ({ item, order }))
    .filter(({ item, order }) => getOrder(item) !== order);
};

// New items go to the top.
export const topOrder = (orders: (number | null | undefined)[]) => {
  const known = orders.filter((order): order is number => typeof order === 'number');
  return known.length ? Math.min(...known) - 1 : 0;
};
